import ApiFactory from '@/factories/ApiFactory';
import { prepAutocompleteData, prepOptionValues, serialize } from '@/services/UtilityService';

const getSEO = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`systemadmin/v1/seo?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createSEO = (body) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`systemadmin/v1/seo`, body).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateSEO = (id, body) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`systemadmin/v1/seo/${id}`, body).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const deleteSEO = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.delete(`systemadmin/v1/seo/${id}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getBusinessCategories = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`businesses/v1/types?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getBlocks = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/app/blocks?${query}`).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'categoryName', 'categoryID'));
			},
			(error) => reject(error)
		);
	});
};

const takeAway = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`campaigns/v1/types?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getConfigurations = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/app/configurator/homepage?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getWebConfigurations = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`web/v1/homepage?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getCampaigns = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/campaigns?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createCampaign = (data) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`marketing/v1/campaigns`, data).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateCampaign = (data) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/campaigns/${data.id}`, data).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getCampaignDetails = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/campaigns/${id}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getCampaignTypes = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/campaigns/types`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const getBlockBannerTypes = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/app/blocks/options/banner_types`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const getCampaignPositions = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/campaigns/positions`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const getCampaignRedirectTypes = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/campaigns/redirect_types`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const getContentTypes = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/app/blocks/options/content_types`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const getContentFormatTypes = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/app/blocks/options/content_format_types`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const updateBusinessCategoryOrder = (id, data) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`businesses/v1/types/${id}`, data).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateMainBannerOrder = (id, newOrder) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/campaigns/${id}/order/${newOrder}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateSubCategoryOrder = (id, newOrder) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/app/subcategories/${id}/order/${newOrder}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateBlockOrder = (id, newOrder) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/app/blocks/${id}/order/${newOrder}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getHomeBlockData = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/app/blocks/${id}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateSubBlockOrder = (url) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(url).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getSubCategoryData = (id) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/app/subcategories/${id}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createBusinessCategory = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`businesses/v1/types`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateBusinessCategory = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`businesses/v1/types/${payload.id}`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getDisclaimers = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize({ ...filters, onlyValid: -1 });
		ApiFactory.get(`marketing/v1/app/notifications?${query}`).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'title', 'id'));
			},
			(error) => reject(error)
		);
	});
};

const getDisclaimer = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/app/notifications/last?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createDisclaimer = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`marketing/v1/app/notifications`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateDisclaimer = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/app/notifications/${payload.id}`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createBlock = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`marketing/v1/app/blocks`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateBlock = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/app/blocks/${payload.categoryID}`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createFilter = (data) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`marketing/v1/filters`, data).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateFilter = (data) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/filters/${data.id}`, data).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const autoGeneratedOptions = (contentType) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`/marketing/v1/app/blocks/options/auto_generated/${contentType}`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const updateBlockStatus = (id, status) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`/marketing/v1/app/blocks/${id}/status/${status}`).then(resolve, reject);
	});
};

const getViews = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/campaigns/view_types?${query}`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data));
			},
			(error) => reject(error)
		);
	});
};

const getSubBlocks = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/app/sub_blocks?${query}`).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'categoryName', 'categoryID'));
			},
			(error) => reject(error)
		);
	});
};

const getFilterTypes = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/filters/types`).then(
			({ data }) => {
				resolve(prepAutocompleteData(data.data, 'description', 'code'));
			},
			(error) => reject(error)
		);
	});
};

const getFilterParameters = (flag) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`marketing/v1/filters/types/${flag}/parameternames`).then(
			({ data }) => {
				resolve(prepOptionValues(data.data, 'description', 'code'));
			},
			(error) => reject(error)
		);
	});
};

const updateFilterOrder = (id, order) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/filters/${id}/order/${order}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getSubCategories = (filters) => {
	return new Promise((resolve, reject) => {
		const query = serialize(filters);
		ApiFactory.get(`marketing/v1/app/subcategories?${query}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createSubCategory = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`marketing/v1/app/subcategories`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateSubCategory = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/app/subcategories/${payload.categoryID}`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createSubBlock = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`marketing/v1/app/sub_blocks`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateSubBlock = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`marketing/v1/app/sub_blocks/${payload.categoryID}`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const createWebBanner = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.post(`banners/v1/web`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const updateWebBanner = (payload) => {
	return new Promise((resolve, reject) => {
		ApiFactory.put(`banners/v1/web/${payload.id}`, payload).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

export default {
	getSEO,
	createSEO,
	updateSEO,
	deleteSEO,
	getBusinessCategories,
	getBlocks,
	takeAway,
	getConfigurations,
	getWebConfigurations,
	getCampaigns,
	createCampaign,
	updateCampaign,
	getCampaignDetails,
	getCampaignTypes,
	getCampaignPositions,
	getCampaignRedirectTypes,
	getContentTypes,
	getContentFormatTypes,
	updateBusinessCategoryOrder,
	updateMainBannerOrder,
	updateSubCategoryOrder,
	updateBlockOrder,
	getHomeBlockData,
	updateSubBlockOrder,
	getSubCategoryData,
	createBusinessCategory,
	updateBusinessCategory,
	getDisclaimers,
	getDisclaimer,
	createDisclaimer,
	updateDisclaimer,
	createBlock,
	updateBlock,
	createFilter,
	updateFilter,
	autoGeneratedOptions,
	updateBlockStatus,
	getBlockBannerTypes,
	getViews,
	getSubBlocks,
	getFilterTypes,
	getFilterParameters,
	updateFilterOrder,
	getSubCategories,
	createSubCategory,
	updateSubCategory,
	createSubBlock,
	updateSubBlock,
	createWebBanner,
	updateWebBanner,
};
